<app-filter-area
  (emitterEventActionClick)="handleFilterAreaEvent($event)"
>
  <app-input
    type="date"
    [label]="'DASHBOARD.FILTERS.START_DATE' | translate"
    [placeholder]="'DASHBOARD.FILTERS.START_DATE_PLACEHOLDER' | translate"
    [control]="form.get('dateFrom')"
  />
  <app-input
    type="date"
    [label]="'DASHBOARD.FILTERS.END_DATE' | translate"
    [placeholder]="'DASHBOARD.FILTERS.END_DATE_PLACEHOLDER' | translate"
    [control]="form.get('dateTo')"
  />
  <app-select
    [label]="'DASHBOARD.FILTERS.DISPLAY_MODE' | translate"
    [placeholder]="'DASHBOARD.FILTERS.DISPLAY_MODE_PLACEHOLDER' | translate"
    [control]="form.get('granularity')"
    [items]="granularityOptions"
  />
</app-filter-area>

<div class="big-numbers">
  @for (item of bigNumbers; track item.title) {
    <div class="card">
      <div class="card-header">
        <span class="label">{{ item.title }}</span>
        <i
          class="material-symbols-outlined info-icon"
          [title]="item.description">
          info
        </i>
      </div>
      @if (item.value === 'null%') {
        <span class="value">Sem base de comparação</span>
      } @else {
        <span class="value">{{ item.value }}</span>
      }
    </div>
  } @empty {
    <span class="empty-message">
      Nenhum indicador encontrado para o período selecionado.
    </span>
  }
</div>

<section class="chart-card">
  <div class="chart-header">
    <div>
      <h2>Comparativo de Vendas</h2>
      <p>Faturamento por período selecionado</p>
    </div>
  </div>

  @if (comparisonChartData.length) {
    <div class="chart-content">
      <div
        class="chart-wrapper"
        [style.width]="chartWidth"
        [style.min-width]="'calc(100% - 15px)'"
      >
        <google-chart
          [type]="comparisonChartType"
          [columns]="comparisonChartColumns"
          [data]="comparisonChartData"
          [options]="comparisonChartOptions">
        </google-chart>
      </div>
    </div>
  } @else {
    <div class="chart-state">
      <i class="material-symbols-outlined">bar_chart</i>
      <span>Nenhum dado encontrado para o período selecionado.</span>
    </div>
  }
</section>

<section class="chart-card">
  <div class="chart-header">
    <div>
      <h2>Evolução das Vendas</h2>
      <p>Vendas por período selecionado</p>
    </div>

    <div>
      <div class="legend">
        <div class="revenue"></div>
        <p>Quantidade de vendas</p>
      </div>

      <div class="legend">
        <div class="sales"></div>
        <p>Faturamento</p>
      </div>
    </div>
  </div>

  @if (salesEvolutionData.length) {
    <div class="chart-content">
      <div
        class="chart-wrapper"
        [style.width]="salesEvolutionWidth"
        [style.min-width]="'calc(100% - 15px)'"
      >
        <google-chart
          [type]="salesEvolutionType"
          [columns]="salesEvolutionColumns"
          [data]="salesEvolutionData"
          [options]="salesEvolutionOptions">
        </google-chart>
      </div>
    </div>
  } @else {
    <div class="chart-state">
      <i class="material-symbols-outlined">bar_chart</i>
      <span>Nenhum dado encontrado para o período selecionado.</span>
    </div>
  }
</section>
